import WalletProvisioningScreen from 'features/onboarding/screens/WalletProvisioning/WalletProvisioningScreen';
import React from 'react';

export default function OnboardingWalletProvisioningPage() {
  return <WalletProvisioningScreen />;
}
